import { apiClient } from '../client';
import { dineEndpoints } from '../endpoints/dine.endpoints';
import { call } from './unwrap';
import type { OutletBriefDto, OutletDto } from '../types/dine.types';

export const outletService = {
  /** GET /outlet */
  get(): Promise<OutletDto> {
    return call<OutletDto>(apiClient.get(dineEndpoints.outlet()), 'Could not load the outlet');
  },

  /** GET /outlets/mine — the outlets this waiter may work in; asked once at sign-in. */
  mine(): Promise<OutletBriefDto[]> {
    return call<OutletBriefDto[]>(apiClient.get(dineEndpoints.myOutlets()), 'Could not load your outlets').then((o) => o ?? []);
  },
};
